import React from 'react';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Badge from 'react-bootstrap/Badge';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { deleteUser } from '../Redux/Actions/AuthActions';
import './CardUser.css';

const CardUser = ({ el }) => {
  const dispatch = useDispatch();

  if (!el) return null;

  const getRoleBadgeBg = (role) => {
    switch (role) {
      case 'admin': return 'danger';
      case 'useradmin': return 'warning';
      case 'usertwinpark': return 'info';
      case 'userwellness': return 'success';
      case 'userspintoss': return 'primary';
      default: return 'secondary';
    }
  };

  return (
    <div className="card-container h-100">
      <Card className="user-card h-100 border-0 shadow-sm" style={{ backgroundColor: '#1e202d', color: '#fff' }}>
        <Card.Body className="d-flex flex-column justify-content-between">
          <div>
            <div className="d-flex justify-content-between align-items-start mb-2">
              <Card.Title className="fw-bold mb-0 text-white" style={{ fontSize: '1.05rem' }}>
                {el.name || 'Sans Nom'}
              </Card.Title>
              <Badge bg={getRoleBadgeBg(el.role)} className="text-capitalize ms-2">
                {el.role || 'user'}
              </Badge>
            </div>
            <Card.Subtitle className="mb-2 text-info text-break" style={{ fontSize: '0.85rem' }}>
              {el.email}
            </Card.Subtitle>
            {el.matricule && (
              <p className="mb-1 text-light opacity-75 small">
                <strong>Matricule:</strong> {el.matricule}
              </p>
            )}
            {el.fonction && (
              <p className="mb-1 text-light opacity-75 small">
                <strong>Fonction:</strong> {el.fonction}
              </p>
            )}
            {el.phone && (
              <p className="mb-1 text-light opacity-75 small">
                <strong>Tél:</strong> {el.phone}
              </p>
            )}
          </div>

          <div className="button-container d-flex gap-2 mt-3">
            <Button
              size="sm"
              as={Link}
              to={`/UpdateUser/${el._id}`}
              variant="outline-primary"
              className="flex-fill"
            >
              ✏️ Modifier
            </Button>
            <Button
              size="sm"
              variant="outline-danger"
              onClick={() => {
                if (window.confirm(`Voulez-vous vraiment supprimer ${el.name || "cet utilisateur"} ?`)) {
                  dispatch(deleteUser(el._id));
                }
              }}
              className="flex-fill"
            >
              🗑️ Supprimer
            </Button>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default CardUser;
